import React from "react";

import { getClosureFor } from "@kazoohr/helpers";

import { Divider } from "../Divider";
import { Spacer } from "../Grid";
import { Heading } from "../Heading";

import { CloseDrawerButton } from "./CloseDrawerButton";
import styles from "./Drawer.scss";

export interface DrawerHeaderProps {
  /**
   * Function to handle what happens when user input (e.g., clicking outside of the drawer or sliding it shut) closes the drawer.
   */
  onSetOpen:
    | ((isOpen?: boolean) => void)
    | ((isOpen?: string) => void)
    | React.Dispatch<React.SetStateAction<boolean | undefined>>
    | React.Dispatch<React.SetStateAction<string>>
    | React.Dispatch<React.SetStateAction<string | undefined>>
    | React.Dispatch<React.SetStateAction<boolean>>;
  /**
   * If showing the window close button and you want text, pass it in here. Note: you must handle i18n yourself.
   */
  closeButtonText?: string;
  /**
   * Give the drawer a header title.
   */
  title: string | JSX.Element;
}

/**
 * The header for the drawer. You are able to use the DrawerHeader independently
 * if necessary to set a drawer header that is not stuck to the drawer's header.
 */
export function DrawerHeader({
  onSetOpen,
  closeButtonText = "",
  title,
}: DrawerHeaderProps) {
  return (
    <div className={styles.drawerHeaderContainer}>
      <CloseDrawerButton
        text={closeButtonText}
        onClick={getClosureFor(onSetOpen, false)}
      />
      <div className={styles.drawerHeaderWrapper}>
        <Heading level="2">{title}</Heading>
        <Spacer />
        <Divider />
      </div>
    </div>
  );
}
